import { useState } from 'react';

import { FaArrowDown, FaArrowUp, FaEdit, FaEllipsisH, FaRegTrashAlt } from "react-icons/fa";

import classes from './AdvertiseServices.module.css';

import { getAuthToken } from '../util/auth.jsx'
import backend from '../util/backend.jsx';
import { EDIT_OPEN } from '../util/advertiseEditState.jsx';
import { rows } from '../util/helpers.jsx';

import EditService from '../components/EditService.jsx';
import LogoImage from './LogoImage.jsx';

function ViewAdvertiseService({ srv, editState, setEditState, srvInfoEditted, minOrder, maxOrder }) {

  const [editForm, setEditForm] = useState(false);

  const limit = 5;

  console.log(`ViewAdvertiseService: id: ${srv.id} title: ${srv.title} do: ${srv.display_order} po: ${srv.prev_order} no: ${srv.next_order}`);

  function editService(id) {
    console.log(`Edit Service: ${id}`);
    srvInfoEditted();
    setEditForm(true);
  }

  async function deleteService(id) {
    console.log(`Delete Service: ${id}`);

    const token = getAuthToken();
    const response = await fetch(`https://${backend}/deladvertiseservice?id=${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    const result = await response;

    window.location.reload();
    srvInfoEditted();

    return result;
  }

  async function updateOrder(id, display_order) {
    const token = getAuthToken();
    const orderData = {display_order};
    const response = await fetch(`https://${backend}/advertiseserviceorder?id=${id}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(orderData)
    });
    const result = await response;
    console.log(`updateOrder result: ${JSON.stringify(result)}`);
    return result;
  }

  async function moveUpService(srv) {
    console.log(`moveUp Service: ${srv.id} move from ${srv.display_order} to ${srv.prev_order}`);
    console.log(`moveUp Service: ${srv.pre_id} move from ${srv.prev_order} to ${srv.display_order}`);

    updateOrder(srv.id, srv.prev_order);
    updateOrder(srv.prev_id, srv.display_order);

    window.location.reload();
    srvInfoEditted();

    return;
  }

  async function moveDownService(srv) {
    console.log(`moveDown Service: ${srv.id} move from ${srv.display_order} to ${srv.next_order}`);
    console.log(`moveDown Service: ${srv.next_id} move from ${srv.next_order} to ${srv.display_order}`);

    updateOrder(srv.id, srv.next_order);
    updateOrder(srv.next_id, srv.display_order);

    window.location.reload();
    srvInfoEditted();

    return;
  }

  return (
    <>
    {editForm ?
      <>
      <td colspan={2}>
        <EditService srv={srv} editState={editState} setEditState={setEditState} setEditForm={setEditForm} />
      </td>
      </>
    :
      <>
      <td>
      <div className={classes.service}>
        <span>
          <LogoImage
            title={srv.title}
            logo_contents={srv.icon_contents}
            logo_filetype={srv.icon_filetype}
            url={srv.website}
          />
        </span>
        <span>
          <p>{srv.title}</p>
          <textarea
            id="services-description"
            name="services-description"
            rows={rows(srv.description, limit)}
            cols={60}
            readonly
            value={srv.description}
          />
        </span>
      </div>
    </td>
    <td>
      <div className={classes.service}>
        {(srv.prev_order > 0) ?
          <button disabled={!editState[EDIT_OPEN]} onClick={() => {moveUpService(srv)}}>
            <ul>
            <li>
              <FaArrowUp />
            </li>
            <li>
              Move Up
            </li>
            </ul>
          </button>
        :
          <button disabled className={classes.noselect}>
            <ul>
            <li>
              <FaEllipsisH />
            </li>
            <li>
              Top
            </li>
            </ul>
          </button>
        }
        {(srv.next_order > 0) ?
          <button disabled={!editState[EDIT_OPEN]} onClick={() => {moveDownService(srv)}}>
            <ul>
            <li>
              <FaArrowDown />
            </li>
            <li>
              Move Down
            </li>
            </ul>
          </button>
        :
          <button disabled className={classes.noselect}>
            <ul>
            <li>
              <FaEllipsisH />
            </li>
            <li>
              Bottom
            </li>
            </ul>
          </button>
        }
        <button disabled={!editState[EDIT_OPEN]} onClick={() => {editService(srv.id)}}>
          <ul>
          <li>
            <FaEdit />
          </li>
          <li>
            Edit
          </li>
          </ul>
        </button>
        <button disabled={!editState[EDIT_OPEN]} onClick={() => {if (window.confirm(`Delete ${srv.title}, are you sure?`)) deleteService(srv.id)}}>
          <ul>
          <li>
            <FaRegTrashAlt />
          </li>
          <li>
            Delete
          </li>
          </ul>
        </button>
      </div>
      </td>
      </>
    }
    </>
  );
}

export default ViewAdvertiseService;
